// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hc4e-","icon":"styles_icon__3wU4i"};